export var BooleanMatchType;
(function (BooleanMatchType) {
    BooleanMatchType[BooleanMatchType["IsTrue"] = 0] = "IsTrue";
    BooleanMatchType[BooleanMatchType["IsFalse"] = 1] = "IsFalse";
    BooleanMatchType[BooleanMatchType["IsNotEmpty"] = 2] = "IsNotEmpty";
    BooleanMatchType[BooleanMatchType["IsEmpty"] = 3] = "IsEmpty";
    BooleanMatchType[BooleanMatchType["Equals"] = 4] = "Equals";
})(BooleanMatchType || (BooleanMatchType = {}));
;
